import React from 'react';

import logoUrl from '../../assets/images/trqk_logo_639w_black.svg';

interface TrqkIQLogoProps {
    width: number;
}

export const TrqkLogo = ({ width }: TrqkIQLogoProps): JSX.Element => (
    <img alt="Trqk logo" src={logoUrl} width={width} />
);
